import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

interface LetterNavItem {
  path: string;
  letter: string;
  label: string;
  color: string;
}

@Component({
  selector: 'app-letter-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './letter-nav.component.html',
  styleUrl: './letter-nav.component.scss'
})
export class LetterNavComponent {
  readonly items: LetterNavItem[] = [
    { path: '/diagnostico', letter: 'D', label: 'Diagnóstico', color: 'blue' },
    { path: '/intervencao', letter: 'I', label: 'Intervenção', color: 'blue' },
    { path: '/monitoramento', letter: 'M', label: 'Monitoramento', color: 'pink' },
    { path: '/ajuste', letter: 'A', label: 'Ajuste', color: 'pink' },
    { path: '/integracao', letter: 'I', label: 'Integração', color: 'green' },
    { path: '/sustentacao', letter: 'S', label: 'Sustentação', color: 'pink' }
  ];
}
